import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFile } from "sr/utils/api/getFile";
import { getFiles } from "sr/utils/api/getFiles";

export const fetchProfileImg = createAsyncThunk('profileimg', async (params:any)=> {
    const profileImg = await getFiles(params)
      if(profileImg?.success===true) {
    const filterfile = profileImg?.data?.filter((item)=> item?.file?.fieldname==='profile_img')
    if(filterfile && filterfile[0]?.file?.key) {
      const fileimg = await getFile(filterfile[0]?.file?.key);
      
      if(fileimg) {
      const newImageUrl = URL.createObjectURL(fileimg);
      return newImageUrl;
      }
      
    }}
})

interface initialState {
    data:any,
    isLoading:boolean,
    isError:boolean
}

const initialState:initialState = {
    data:null,
    isLoading:false,
    isError:false
}
const ProfileImgSlice = createSlice({
    name:'FetchProfileImg',
    initialState,
    extraReducers:(builder)=>{
        builder.addCase(fetchProfileImg.pending, (state, action)=>{
            state.isLoading = true
        })
        builder.addCase(fetchProfileImg.fulfilled, (state, action)=>{
            state.data = action.payload;
        })
        builder.addCase(fetchProfileImg.rejected, (state, action)=>{
            state.isError = true
        })
    },
    reducers:undefined
})
export default ProfileImgSlice.reducer